import request from 'utils/request';
import config from 'config/Config';

export default class {
  // 图文创作详情
  static getWordImageDetail(id) {
    return request({
      url: `creator/word/image/shareInfo/${id}`,
      method: 'GET',
      host: config.HOST_PROMOTE
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/AICreation/AIImageText/AIImageTextServ.js